import { change } from 'redux-form';
import { Dispatch } from 'redux';
import { fromJS } from 'immutable';

import { MethodResponse } from '../../types';

interface Picture {
  id: string;
  resource: string;
  categories: Array<string>;
}

export const setDefaultPicture = (
  pictures: Array<Picture>,
  form: string,
  categories: Array<string>,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: Dispatch<any>
): Promise<MethodResponse | void> => {
  if (pictures && pictures.length > 0) {
    const matchingPictures = pictures.filter((picture) => {
      if (!picture.categories || picture.categories.length === 0) {
        return false; // Skip pictures without categories
      }

      return picture.categories.some((pictureCategory) => categories.includes(pictureCategory));
    });

    if (matchingPictures.length > 0) {
      const randomIndex = Math.floor(Math.random() * matchingPictures.length);
      const selectedPicture = matchingPictures[randomIndex];

      dispatch(change(String(form), 'pictures', fromJS([selectedPicture.resource])));
    } else {
      const randomIndex = Math.floor(Math.random() * pictures.length);
      const fallbackPicture = pictures[randomIndex];

      dispatch(change(String(form), 'pictures', fromJS([fallbackPicture.resource])));
    }
  }

  return Promise.resolve();
};
